import React from "react";
import { ShieldAlert, X } from "lucide-react";

const displayValue = value => value === null || value === undefined || value === "" ? "-" : value;
const formatDate = value => value ? new Date(Number(value)).toLocaleString() : "-";

function DeviceViolationDetailsPopup({ violation, onClose }) {
    const fields = [
        ["Device", violation.device],
        ["IP Address", violation.ip],
        ["User", violation.user],
        ["Unauthorized Action", violation.action],
        ["Violation Date", formatDate(violation.startTime)],
        ["Severity", violation.severity],
        ["Source", violation.source],
        ["Details", violation.details]
    ];

    return (
        <div className="oct-shared-popup" role="dialog" aria-modal="true" aria-labelledby="device-violation-details-title">
            <div className="oct-shared-popup__backdrop" onClick={onClose} />
            <div className="oct-shared-popup__dialog device-violation-details-dialog" onClick={event => event.stopPropagation()}>
                <div className="oct-shared-popup__header">
                    <div className="oct-shared-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon"><ShieldAlert size={18} /></div>
                        <div>
                            <h4 id="device-violation-details-title" className="oct-shared-popup__title">Device Violation Details</h4>
                            <p className="oct-shared-popup__subtitle">Unauthorized device activity detected from syslog.</p>
                        </div>
                    </div>
                    <button type="button" className="oct-shared-popup__close" onClick={onClose} aria-label="Close device violation details">
                        <X size={18} />
                    </button>
                </div>
                <div className="oct-shared-popup__body oct-shared-popup__body--form device-violation-details-grid">
                    {fields.map(([label, value]) => (
                        <div className="oct-shared-popup__field" key={label}>
                            <span className="oct-shared-popup__label">{label}</span>
                            <div className="oct-shared-popup__input">{displayValue(value)}</div>
                        </div>
                    ))}
                </div>
                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn oct-shared-popup__btn oct-shared-popup__btn--primary" onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
}

export default DeviceViolationDetailsPopup;
